export const setCSSProperty = (node, name, value) => {
  (node instanceof HTMLElement ? node : document.documentElement).style.setProperty(name, value);
};

export default {
  setCSSProperty,
};
